(function () {
  'use strict';

  var VIEW_ALL_SELECTOR = '.collection__view-all a';
  var MAX_PAGES = 12;
  var appendCounter = 0;

  function addPreviewParameters(url) {
    var current = new URL(window.location.href);
    ['preview_theme_id', 'preview_key'].forEach(function (name) {
      if (current.searchParams.has(name) && !url.searchParams.has(name)) {
        url.searchParams.set(name, current.searchParams.get(name));
      }
    });
    return url;
  }

  function productKey(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;

    try {
      var url = new URL(link.href, window.location.origin);
      return url.pathname.replace(/\/$/, '');
    } catch (error) {
      return link.getAttribute('href');
    }
  }

  function sourceItems(documentNode) {
    var selectors = [
      '#product-grid > li.grid__item',
      'ul#product-grid > li',
      'ul.product-grid > li.grid__item',
      '.product-grid > .grid__item'
    ];

    for (var index = 0; index < selectors.length; index += 1) {
      var items = Array.prototype.slice.call(documentNode.querySelectorAll(selectors[index]));
      if (items.length) return items;
    }

    return [];
  }

  function nextPageUrl(documentNode) {
    var links = Array.prototype.slice.call(documentNode.querySelectorAll('.pagination a, a[rel="next"]'));
    var next = links.find(function (link) {
      var label = link.getAttribute('aria-label') || '';
      var rel = link.getAttribute('rel') || '';
      return rel.toLowerCase() === 'next' || /next/i.test(label);
    });

    if (!next) return null;
    return addPreviewParameters(new URL(next.href, window.location.origin));
  }

  function replaceIdReferences(root, idMap) {
    var tokenAttributes = ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'form'];

    Array.prototype.slice.call(root.querySelectorAll('*')).forEach(function (element) {
      tokenAttributes.forEach(function (attribute) {
        var value = element.getAttribute(attribute);
        if (!value) return;

        var updated = value
          .split(/\s+/)
          .map(function (token) { return idMap[token] || token; })
          .join(' ');
        element.setAttribute(attribute, updated);
      });

      ['data-modal', 'href'].forEach(function (attribute) {
        var value = element.getAttribute(attribute);
        if (!value || value.charAt(0) !== '#') return;
        var target = value.slice(1);
        if (idMap[target]) element.setAttribute(attribute, '#' + idMap[target]);
      });
    });
  }

  function prepareClone(item) {
    appendCounter += 1;
    var suffix = '-sv-inline-' + appendCounter;
    var clone = item.cloneNode(true);
    var idMap = {};

    clone.classList.remove('slider__slide');
    clone.style.removeProperty('width');
    clone.style.removeProperty('max-width');

    if (clone.id) {
      idMap[clone.id] = clone.id + suffix;
      clone.id = idMap[clone.id.replace(suffix, '')];
    }

    Array.prototype.slice.call(clone.querySelectorAll('[id]')).forEach(function (element) {
      var originalId = element.id;
      var newId = originalId + suffix;
      idMap[originalId] = newId;
      element.id = newId;
    });

    replaceIdReferences(clone, idMap);
    return clone;
  }

  function expandCurrentGrid(container, list) {
    var sliderComponent = list.closest('slider-component');
    if (sliderComponent) sliderComponent.classList.add('sv-inline-expanded');

    ['slider', 'slider--tablet', 'slider--desktop', 'grid--peek'].forEach(function (className) {
      list.classList.remove(className);
    });

    Array.prototype.slice.call(list.children).forEach(function (item) {
      item.classList.remove('slider__slide');
      item.style.removeProperty('width');
      item.style.removeProperty('max-width');
    });

    Array.prototype.slice.call(container.querySelectorAll('.slider-buttons')).forEach(function (controls) {
      controls.hidden = true;
    });
  }

  async function fetchDocument(url) {
    var response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) throw new Error('Unable to load collection products.');
    var html = await response.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  async function appendRemainingProducts(link, list) {
    var existingKeys = new Set();
    Array.prototype.slice.call(list.children).forEach(function (item) {
      var key = productKey(item);
      if (key) existingKeys.add(key);
    });

    var url = addPreviewParameters(new URL(link.href, window.location.origin));
    var pagesLoaded = 0;
    var appended = 0;

    while (url && pagesLoaded < MAX_PAGES) {
      pagesLoaded += 1;
      var documentNode = await fetchDocument(url);
      var items = sourceItems(documentNode);

      items.forEach(function (item) {
        var key = productKey(item);
        if (!key || existingKeys.has(key)) return;
        existingKeys.add(key);
        list.appendChild(prepareClone(item));
        appended += 1;
      });

      url = nextPageUrl(documentNode);
    }

    return appended;
  }

  function showError(container, text) {
    var existing = container.querySelector('.sv-inline-collection-message');
    if (existing) existing.remove();

    var message = document.createElement('p');
    message.className = 'sv-inline-collection-message';
    message.textContent = text;
    container.appendChild(message);
  }

  function bindViewAll(link) {
    if (link.dataset.svInlineExpansionBound === 'true') return;

    var container = link.closest('.collection') || link.closest('.shopify-section');
    var list = container ? container.querySelector('ul.product-grid') : null;
    if (!container || !list) return;

    link.dataset.svInlineExpansionBound = 'true';
    link.addEventListener('click', async function (event) {
      event.preventDefault();
      if (link.dataset.svInlineExpansionLoading === 'true') return;

      link.dataset.svInlineExpansionLoading = 'true';
      link.setAttribute('aria-busy', 'true');
      var originalText = link.textContent;
      link.textContent = 'Loading products...';

      expandCurrentGrid(container, list);

      try {
        await appendRemainingProducts(link, list);
        expandCurrentGrid(container, list);
        var wrapper = link.closest('.collection__view-all');
        if (wrapper) wrapper.hidden = true;
        window.dispatchEvent(new Event('resize'));
      } catch (error) {
        link.textContent = originalText;
        link.removeAttribute('aria-busy');
        link.dataset.svInlineExpansionLoading = 'false';
        showError(container, 'The additional products could not be loaded. Please try again.');
      }
    });
  }

  function initialise(root) {
    Array.prototype.slice.call((root || document).querySelectorAll(VIEW_ALL_SELECTOR)).forEach(bindViewAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); }, { once: true });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target || document);
  });
})();
